import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from "../../_services/authentication.service";

@Component({
  selector: 'bxl-presenter-login',
  templateUrl: 'presenter-login.component.html',
})
export class PresenterLoginComponent implements OnInit {

  initialized = false;
  errorMessage = "";

  constructor(private router: Router, private route: ActivatedRoute, private auth: AuthenticationService) {

  }

  ngOnInit(): void {
    let token = this.route.snapshot.queryParamMap.get('presenter');
    console.log(token);
    let id = this.route.snapshot.paramMap.get('id');
    console.log('eventID' + id);
    this.auth.refreshClaimsWithPresenterGuid(token).subscribe(result => {
      this.initialized = true;
      this.router.navigate(['/live-events', id , 'presenter-dashboard']);
    }, error => {
      this.errorMessage= "There was an error connecting to the event. Please try again later.";
    });
  }
}
